import { render, staticRenderFns } from "./RetrospectChangelog.vue?vue&type=template&id=95d99096&scoped=true"
import script from "./RetrospectChangelog.vue?vue&type=script&lang=js"
export * from "./RetrospectChangelog.vue?vue&type=script&lang=js"
import style0 from "./RetrospectChangelog.vue?vue&type=style&index=0&id=95d99096&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d99096",
  null
  
)

export default component.exports